export default __webpack_public_path__ + "static/media/create-workspace-success.b673c77f.svg";